import { render, staticRenderFns } from "./MapaDepartamentosSegunda.vue?vue&type=template&id=0b10ba2e&"
import script from "./MapaDepartamentosSegunda.vue?vue&type=script&lang=js&"
export * from "./MapaDepartamentosSegunda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports